<div class="d-flex">
  <div class="landing-container">
    <div
      class="parent"
      #elemt
      (mousedown)="startDragging($event, false, elemt)"
      (mouseup)="stopDragging($event, false)"
      (mouseleave)="stopDragging($event, false)"
      (mousemove)="moveEvent($event, elemt)"
    >
      <div class="child">
        <div class="preview-fixes" [innerHtml]="page?.previewHtml"></div>
      </div>
    </div>
  </div>

  <div class="ms-5 mt-5">
    <div>
      <div>
        <span class="font-weight-bold" translate>stats_pages_details_resum_pagetitle </span>
        <span>{{ page?.description }}</span>
      </div>

      <div>
        <span class="font-weight-bold" translate>stats_pages_details_resum_pagelink </span>
        <span
          ><a [href]="url" target="_blank" class="url-online">{{ url }}</a></span
        >
      </div>
    </div>

    <div class="mt-3">
      <table class="table">
        <thead>
          <tr>
            <th translate>stats_pages_details_resum_published_period</th>
            <th translate>stats_pages_details_resum_published_days</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let period of pageUpTime?.pageUpTime">
            <td>
              {{ formatDate(period.startDate) }} - {{ period.endDate ? formatDate(period.endDate) : ('stats_dates_today' | translate) }}
            </td>
            <td>{{ period?.numDays }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>
